// react
import { ReactNode, createContext, useState, useMemo } from 'react';
import { OrderType } from 'types/order';

type AspOrderType = Partial<OrderType> | null;

export type AspContextType = {
  isThanks: boolean;
  setIsThanks: (value: boolean) => void;
  order: AspOrderType;
  setOrder: (value: AspOrderType) => void;
};

type AspProviderProps = {
  children: ReactNode;
};

const AspContext = createContext<AspContextType | null>(null);

export const AspProvider = ({ children }: AspProviderProps) => {
  const [isThanks, setIsThanks] = useState<boolean>(false);
  const [order, setOrder] = useState<AspOrderType>(null);

  const AspContextValue = useMemo(() => ({ isThanks, setIsThanks, order, setOrder }), [isThanks, order]);

  return <AspContext.Provider value={AspContextValue}>{children}</AspContext.Provider>;
};

export default AspContext;
